import * as React from 'react';
import classnames from 'classnames';

const ToastElement = ({
    appearance,
    id,
    children,
    transitionState,
    onDismiss,
    ...props
}) => (
    /**
     * appearance: success, error, info, warning
     * id: random string
     * autoDismiss: false
     * autoDismissTimeout: 5000
     * isRunning: false
     * onDismiss: ƒ ()
     * onMouseEnter: ƒ NOOP()
     * onMouseLeave: ƒ NOOP()
     * pauseOnHover: undefined
     * placement: "top-right"
     * transitionDuration: 220
     * transitionState: "exited"
     */
    <div
        id={id}
        className={classnames('toast-element', {
            'toast-element--success': appearance === 'success',
            'toast-element--warning': appearance === 'warning',
            'toast-element--error': appearance === 'error',
            'toast-element--info': appearance === 'info',
            exited: transitionState === 'exited',
            entered: transitionState === 'entered',
            right: true
        })}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
    >
        <div className="toast-element__icon-box"></div>
        <div className="toast-element__content-box">
            <div className="toast-element__content-box--title">
                {appearance}
            </div>
            <div className="toast-element__content-box--msg">{children}</div>
        </div>
        <div className="toast-element__close" onClick={onDismiss}>
            {' '}
            <i className="nx nx-close"></i>{' '}
        </div>
    </div>
);

export default ToastElement;
